import { Link } from "react-router-dom";
import { SUPPORT_EMAIL, DOMAIN, ASSETS } from "../data";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 bg-mc-bg pt-20 pb-10 px-6 lg:px-10" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 mb-6">
              <img src={ASSETS.icon} alt="MapCast" className="w-9 h-9 rounded-[0.7rem] object-cover ring-1 ring-white/15" />
              <span className="font-display font-extrabold text-xl text-white">MapCast</span>
            </Link>
            <p className="text-mc-muted max-w-sm leading-relaxed font-light">
              The world's AI-powered, real-time location video platform. Broadcast every
              moment. Earn every minute.
            </p>
            <span
              className="group inline-flex items-center gap-2 mt-6 text-sm font-mono uppercase tracking-[0.15em] text-white/70 cursor-default select-none"
              data-testid="footer-live-badge"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-mc-live" /> Live now
            </span>
            <address className="not-italic mt-6 text-sm text-mc-muted leading-relaxed" data-testid="footer-address">
              MapCast BV<br />
              Herengracht 320<br />
              1016 CE Amsterdam, The Netherlands
            </address>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-mc-muted mb-5">Platform</h4>
            <ul className="space-y-3">
              {[
                { l: "Discover", h: "/#discover" },
                { l: "Broadcast", h: "/#broadcast" },
                { l: "Bounties", h: "/#bounties" },
                { l: "FAQ", h: "/#faq" },
              ].map((i) => (
                <li key={i.l}>
                  <a href={i.h} className="text-white/80 hover:text-white transition-colors">{i.l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-mc-muted mb-5">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" className="text-white/80 hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/80 hover:text-white transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
              <li><Link to="/cookies" className="text-white/80 hover:text-white transition-colors" data-testid="footer-cookies-link">Cookie Policy</Link></li>
              <li><Link to="/press" className="text-white/80 hover:text-white transition-colors" data-testid="footer-press-link">Press Kit</Link></li>
              <li><Link to="/investors" className="text-white/80 hover:text-white transition-colors" data-testid="footer-investors-link">Investors</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white transition-colors" data-testid="footer-contact-link">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-sm text-mc-muted font-mono">© {new Date().getFullYear()} {DOMAIN} — All rights reserved.</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-sm text-mc-muted hover:text-white transition-colors font-mono">{SUPPORT_EMAIL}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
